import React from "react";
import AllPage from "../component/sections/page/AllPage";
import AddPage from "../component/sections/page/AddPage";
import ViewPage from "../component/sections/page/ViewPage";
import EditPage from "../component/sections/page/EditPage";

const sitesRoutes = [
  {
    path: "/page/all/publisher/:publisherID",
    render: () => <AllPage />,
    exact: true,
  },
  {
    path: "/page/add/publisher/:publisherID",
    render: () => <AddPage />,
    exact: true,
  },
  {
    path: "/page/view/:pageID",
    render: () => <ViewPage />,
    exact: true,
  },
  {
    path: "/page/edit/:pageID",
    render: () => <EditPage />,
    exact: true,
  },
];

export default sitesRoutes;
